module.exports = __webpack_public_path__ + "img/consult-status.aed360ee.svg";